import React from 'react'
import BaseComponent from '../../../application/baseComponent'
import { punditStore } from '../../stores/punditStore'
import userStore from '../../stores/userStore'
import PunditVbetGraph from './punditVbetGraphComponent'
import PunditVbetSelection from './punditVbetSelectionComponent'
import { fbLogin } from '../../actions/userToolbarActions'
import { hybridLogin } from '../../actions/punditActions'
import { getIsHybrid } from '../../../application/pageDataObject'
import { getIsDesktop } from '../../../utils/ua'
import { hash } from '../../../utils/window'
import { t } from '../../../providers/i18nProvider/i18nProvider'

export default class PunditVbetComponent extends BaseComponent {
  constructor(props) {
    super(props, [punditStore, userStore])
  }

  getState() {
    let { showVbet, matchStarted } = punditStore
    let { isLoggedIn, state: { image: image } } = userStore
    return {
      show: showVbet,
      loggedIn: isLoggedIn || (getIsHybrid() && hash.loggedin),
      userImage: image,
      matchStarted,
    }
  }

  get loginAction() {
    return !getIsHybrid() ? fbLogin.part('pundit') : hybridLogin
  }

  getMainView(show) {
    return show ? (
      <PunditVbetGraph key="mainView" matchStarted={this.state.matchStarted} />
    ) : (
      <PunditVbetSelection key="mainView" />
    )
  }

  signIn(e) {
    e.preventDefault()
    this.loginAction()
  }

  getSignOutBar(loggedIn, show) {
    return !loggedIn && !show && (getIsDesktop() || getIsHybrid()) ? (
      <div key="signOutBar" className="pundit-vbet-component__signIn">
        <a
          ref="loginLink"
          href="#"
          className="pundit-vbet-component__signIn__link"
          onClick={this.signIn.bind(this)}
        >
          {t('pundit.log_in')}{' '}
        </a>
      </div>
    ) : (
      ''
    )
  }

  render() {
    return (
      <div className="pundit-vbet-component">
        {[
          this.getMainView(this.state.show),
          this.getSignOutBar(this.state.loggedIn, this.state.show),
        ]}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/pundit/punditVbetComponent.js